import { useState, useEffect, useContext } from "react"
import { Modal, Button } from "react-bootstrap"
import { Link } from "react-router-dom"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { Card, ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap"
import {
  fetchassignedPatientsAction,
  fetchTodayFollowUpsAction,
  fetchUpcomingFollowUpsAction,
  fetchEmergencyPatientsAction,
  fetchDroppedPatientsAction,
  markEmergencyAction,
  fetchFollowup71221DaysAction,
  fetchAssignedLeadsAction,
  fetchMedicineNotTakenAction,
  fetchRoutedPatientsAction,
} from "../../../store/actions/ServiceCallerAction.js"
import { fetchServiceCallerDashboardAction } from "../../../store/actions/DashboardCardAction.js"
import icon from "../../../../src/assets/images/icons8-call-102.png"
import { ThemeContext } from "../../../context/ThemeContext.jsx"
import Loader from "../Common/Loader.jsx"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { formatDate } from "../../../utils/dateUtils.js"
import { formatName } from "../../../utils/formatName.js"
import reassign from "../../../../src/assets/images/reassign.png"
import emergencyIcon from "../../../../src/assets/images/emergancy.png"
import sendFolloupIcon from "../../../../src/assets/images/chat.png"
import completeIcon from "../../../../src/assets/images/check_11601272.png";
// import FollowupStats from "./FollowupStats";
import { getDoctorsAction } from "../../../store/actions/DoctorsAction.js"
import EmergencyModal from "./EmergencyModal.jsx"
import axiosInstance from "../../../services/AxiosInstance";
import {
  handleSuccess,
  showErrorAlert,
} from "../../../services/ErrorHandlingService";

const ServiceCaller = () => {
  const dispatch = useDispatch()
  const [patients, setPatients] = useState([])
  const [todayFollowUps, setTodayFollowUps] = useState([])
  const [upcomingFollowUps, setUpcomingFollowUps] = useState([])
  const [selectedDoctorForEmergency, setSelectedDoctorForEmergency] = useState("");
  const [showEmergencyModal, setShowEmergencyModal] = useState(false);
  const [emergencyPatient, setEmergencyPatient] = useState(null);

  // Loading states for each card
  const [patientsLoading, setPatientsLoading] = useState(true)
  const [todayFollowUpsLoading, setTodayFollowUpsLoading] = useState(true)
  const [upcomingFollowUpsLoading, setUpcomingFollowUpsLoading] = useState(true)
  const dashboardData = useSelector((state) => {
    console.log("Dashboard Data:", state.dashboard.serviceCallerDashboard)
    return state.dashboard.serviceCallerDashboard || {}
  })
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedCaller, setSelectedCaller] = useState("");
  const [repeatPatients, setRepeatPatients] = useState([]);
  const [repeatLoading, setRepeatLoading] = useState(true);
  const [medicineNotTakenList, setMedicineNotTakenList] = useState([]);
  const [medicineLoading, setMedicineLoading] = useState(true);
  const [otherFollowups, setOtherFollowups] = useState([]);
  const [routedPatients, setRoutedPatients] =
  useState([]);

const [routedLoading, setRoutedLoading] =
  useState(true);
  const [completingLeadId, setCompletingLeadId] = useState(null);
  // Tooltip state management - only one tooltip open at a time
  const [activeTooltip, setActiveTooltip] = useState(null);

  const doctors = useSelector((state) => state?.doctors?.doctors || [])
  const handleReassign = (item) => {
    setSelectedPatient(item);
    setShowReassignModal(true);
  };

  const followup71221Days = useSelector(
    (state) => state.serviceCaller?.followup71221Days || []
  );

  useEffect(() => {
    dispatch(fetchFollowup71221DaysAction());
  }, [dispatch]);

  const serviceCallerList = [
    { id: 1, name: "Caller A" },
    { id: 2, name: "Caller B" },
    { id: 3, name: "Caller C" },
  ];
  // Static data

  const [groupedFollowUps, setGroupedFollowUps] = useState({
    d7: [],
    d15: [],
    d21: [],
  });
  useEffect(() => {
    if (followup71221Days) {
      const formatList = (list = []) =>
        list.map((item) => ({
          id: item.patient_id,
          name: `${item.first_name || ""} ${item.middile_name || ""} ${item.last_name || ""}`.trim(),
          gender: item.gender || "",
          phone: item.whatsapp_contact_no || "",
          patientCode: item.patient_code || "",
        }));

      setGroupedFollowUps({
        d7: formatList(followup71221Days["7Days"]),
        d15: formatList(followup71221Days["15Days"]),
        d21: formatList(followup71221Days["21Days"]),
      });
    }
  }, [followup71221Days]);

  // const [showEmergencyModal, setShowEmergencyModal] = useState(false);
  // const [emergencyPatient, setEmergencyPatient] = useState(null);
  const [emergencyMessage, setEmergencyMessage] = useState("");




  // Access data from Redux state
  const {
    assignedPatients,
    todayFollowUps: reduxTodayFollowUps,
    upcomingFollowUps: reduxUpcomingFollowUps,
    emergencyPatients,
    droppedPatients,

    error,
  } = useSelector((state) => state.serviceCaller)

  useEffect(() => {
    dispatch(fetchServiceCallerDashboardAction())
  }, [dispatch])
  const TotalAssignPatients = dashboardData.TotalAssignPatients || 0
  // Fetch unassigned patients
  useEffect(() => {
    dispatch(fetchEmergencyPatientsAction());
    dispatch(fetchDroppedPatientsAction());

    setRepeatLoading(true);

    dispatch(fetchAssignedLeadsAction())
      .then((res) => {
        if (res.success) {
          setRepeatPatients(res.data);
        }
      })
      .catch((err) => {
        console.error("Repeat Patients Error:", err);
      })
      .finally(() => {
        setRepeatLoading(false); // 🔥 IMPORTANT
      });

  }, [dispatch]);

  useEffect(() => {
    setMedicineLoading(true);

    dispatch(fetchMedicineNotTakenAction())
      .then((res) => {
        if (res.success) {
          setMedicineNotTakenList(res.data);
        }
      })
      .catch((err) => {
        console.error("Medicine Not Taken Error:", err);
      })
      .finally(() => {
        setMedicineLoading(false);
      });
  }, [dispatch]);

  const formatDOB = (date) => {
    if (!date || date === "0000-00-00") return "-";
    const [y, m, d] = date.split("-");
    return `${d}-${m}-${y}`;
  };
  const formatDateTime = (date, time) => {
    if (!date) return "-";
  
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };
  useEffect(() => {
    setPatientsLoading(true)
    dispatch(fetchassignedPatientsAction())
      .then((res) => {
        if (res.success) {
          const formatted = res.data.map((p) => ({
            id: p.patient_id,
            name: formatName(`${p.first_name} ${p.middile_name || ""} ${p.last_name}`.trim()),
            gender: p.gender,
            dob: formatDOB(p.date_of_birth),
            disease: p.diseases?.[0]?.disease_name || "N/A",
            status: p.patient_status,
            createdAt: formatDate(p.created_at, false, true),
            email: p.patient_email,
            phone: p.whatsapp_contact_no,
            patientCode: p.patient_code,
            medicineNotTaken: p.medicineNotTaken || false,
            // medicineNotTaken: true,
            googleReview: false,
            testimonial: false,
            // isRegularServiceCall: p.isRegularServiceCall ?? false,
            // isRegularServiceCall: true,
            // isRegularFollowUp: p.isRegularFollowUp ?? false,
            // isRegularFollowUp: true,
            doctor_id: p.emergencyMark_doctor_id   
          }))
          setPatients(formatted)
        }
      })
      .catch((error) => {
        console.error("Error fetching patients:", error)
      })
      .finally(() => {
        setPatientsLoading(false)
      })
  }, [dispatch])

  // Fetch today's follow-ups

  useEffect(() => {
    setTodayFollowUpsLoading(true);
  
    // ✅ custom formatter (NO timezone issue)
    const formatDateTime = (date, time) => {
      if (!date) return "-";
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year} ${time}`;
    };
  
    dispatch(fetchTodayFollowUpsAction())
      .then((res) => {
        if (res.success) {
  
          // ✅ MAIN TODAY LIST
          const formatted = res.data.map((item) => ({
            name:
              item.first_name && item.last_name
                ? formatName(
                    `${item.first_name} ${item.middile_name || ""} ${item.last_name}`.trim()
                  )
                : "-",
  
            // ✅ FIXED DATE FORMAT
            date: (item.reminder_time),
  
            action: `Follow-up reminder - ${item.reminder_status}`,
            nextAction:
              item.reminder_status === "PENDING"
                ? "Complete reminder"
                : "Follow-up completed",
  
            reminderId: item.reminder_id,
            status: item.reminder_status,
            patientId: item.patient_id,
            prescriptionId: item.prescription_id,
            followupId: item.followup_id,
            whatsappContactNo: item.whatsapp_contact_no,
            adminId: item.admin_id,
            reminderDate: item.reminder_date,
            reminderTime: item.reminder_time,
          }));
  
          setTodayFollowUps(formatted);
  
          // ✅ STORE OTHER FOLLOWUPS (only followup_count)
          setOtherFollowups(res.otherReminders || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching today's follow-ups:", error);
      })
      .finally(() => {
        setTodayFollowUpsLoading(false);
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDoctorsAction());
  }, [dispatch]);

  // Fetch upcoming follow-ups
  useEffect(() => {
    setUpcomingFollowUpsLoading(true)
    dispatch(fetchUpcomingFollowUpsAction())
      .then((res) => {
        if (res.success) {
          const formatted = res.data.map((item) => ({
            name:
              item.first_name && item.last_name
                ? formatName(`${item.first_name} ${item.middile_name || ""} ${item.last_name}`.trim())
                : `Reminder #${item.reminder_id}`,
                date: formatDateTime(item.reminder_date, item.reminder_time),
            action: `Upcoming reminder - ${item.reminder_status}`,
            nextAction: item.reminder_status === "PENDING" ? "Reminder scheduled" : "Follow-up completed",
            reminderId: item.reminder_id,
            status: item.reminder_status,
            patientId: item.patient_id,
            prescriptionId: item.prescription_id,
            followupId: item.followup_id,
            whatsappContactNo: item.whatsapp_contact_no,
            adminId: item.admin_id,
            reminderDate: item.reminder_date,
            reminderTime: item.reminder_time,
          }))
          setUpcomingFollowUps(formatted)
        }
      })
      .catch((error) => {
        console.error("Error fetching upcoming follow-ups:", error)
      })
      .finally(() => {
        setUpcomingFollowUpsLoading(false)
      })
  }, [dispatch])
  useEffect(() => {

    setRoutedLoading(true);
  
    dispatch(fetchRoutedPatientsAction())
      .then((res) => {
  
        if (res.success) {
  
       const formatted = res.data.map((p) => ({
  id: p.patient_id,
  leadId: p.lead_id,
  name:
    `${p.first_name || ""} ${p.middile_name || ""} ${p.last_name || ""}`.trim(),

  assignedAt: p.assigned_at,

  status: p.status,
}));
  
          setRoutedPatients(formatted);
        }
      })
      .catch((err) => {
        console.error(
          "Routed Patients Error:",
          err
        );
      })
      .finally(() => {
        setRoutedLoading(false);
      });
  
  }, [dispatch]);

  const handleCompleteRoute = async (lead_id) => {

    if (completingLeadId) return;
  
    const confirmComplete = await swal({
      title: "Are you sure?",
      text:
        "Do you want to complete this routed patient?",
      icon: "warning",
      buttons: ["Cancel", "Yes, Complete"],
      dangerMode: false,
    });
  
    if (!confirmComplete) {
      return;
    }
  
    setCompletingLeadId(lead_id);
  
    try {
  
      const response =
        await axiosInstance.post(
          "/lead/leadrouteToServicecallerComplete",
          { lead_id }
        );
  
      if (
        response?.status === 200 &&
        response.data?.status === "success"
      ) {
  
        handleSuccess(
          "Success",
          response.data?.message ||
            "Routed patient completed successfully"
        );
  
        dispatch(
          fetchRoutedPatientsAction()
        );
  
      }
  
    } catch (error) {
  
      console.error(
        "Complete Route Error:",
        error
      );
  
      showErrorAlert(
        error?.response?.data?.message ||
          "Something went wrong"
      );
  
    } finally {
  
      setCompletingLeadId(null);
  
    }
  
  };
  const getTooltipPosition = () => "right"

  // State to hold the window width
  const [width, setWidth] = useState(window.innerWidth)

  // Effect to update the width on window resize
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  // Function to determine tooltip placement based on width
  const getTooltipPlacement = () => {
    if (width < 700) {
      return "top"
    } else {
      return "top"
    }
  }

  const handleSendFollowup = (item) => {
    console.log("Sending follow-up schedule to:", item);

    // TODO: WHEN BACKEND IS READY - integrate API call here
    // dispatch(sendFollowupScheduleAction(item.patientId))

    alert(`Follow-up schedule sent to ${item.name} (Testing Only)`);
  };
  // const openEmergencyPopup = (patient) => {
  //   setEmergencyPatient(patient);

  //   // ⭐ ADD THIS — avoid duplicate entry
  //   setEmergencyPatients((prev) => {
  //     if (prev.some(p => p.id === patient.id)) return prev;
  //     return [...prev, patient];
  //   });

  //   const autoMessage =
  //     `🚨 *Emergency Alert* 🚨\n\n` +
  //     `Patient Name: ${patient.name}\n` +
  //     `Gender: ${patient.gender}\n` +
  //     `Phone: ${patient.phone}\n` +
  //     `Disease: ${patient.disease}\n` +
  //     `Status: ${patient.status}\n\n` +
  //     `Please check immediately.`;

  //   setEmergencyMessage(autoMessage);
  //   setShowEmergencyModal(true);
  // };
  const openEmergencyPopup = (patient) => {
    const emergencyData = {
     id: patient.id || patient.patientId,
      name: patient.name || "Unknown",
      gender: patient.gender || "N/A",
      phone: patient.phone || patient.whatsappContactNo || "",
      disease: patient.disease || "N/A",
      status: patient.status || "Active",
      emergencyMark_doctor_id: patient.emergencyMark_doctor_id || null,
      doctor_id: patient.doctor_id || patient.emergencyMark_doctor_id || null,
    };
    setEmergencyPatient(emergencyData);
    setShowEmergencyModal(true);
  };

  const sendEmergencyToDoctor = (payload) => {
    console.log("🚨 FINAL PAYLOAD:", payload);

    // dispatch(markEmergencyAction(payload));
  };
  const closeEmergency = async (patientId) => {
    try {
      const payload = {
        patient_id: patientId,
      };

      console.log("Close Emergency Payload:", payload);

      const response = await axiosInstance.post(
        "/servicecaller/CloseEmergency",
        payload
      );

      if (response?.status === 200) {
        handleSuccess("Emergency closed successfully");

        // Refresh emergency patients list
        dispatch(fetchEmergencyPatientsAction());
      } else {
        showErrorAlert("Failed to close emergency");
      }
    } catch (error) {
      console.error("Close Emergency API Error:", error);

      showErrorAlert(
        error?.response?.data?.message || "Something went wrong"
      );
    }
  };
  // Tooltip handlers - manage single tooltip visibility
  const handleTooltipToggle = (tooltipId) => {
    if (activeTooltip === tooltipId) {
      // Clicking same item toggles it off
      setActiveTooltip(null);
    } else {
      // Clicking different item closes previous and opens new
      setActiveTooltip(tooltipId);
    }
  };

  const handleCloseTooltip = () => {
    setActiveTooltip(null);
  };

  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const tooltipElements = document.querySelectorAll('[class*="tooltip"]');
      let isClickInsideTooltip = false;

      tooltipElements.forEach((element) => {
        if (element.contains(event.target)) {
          isClickInsideTooltip = true;
        }
      });

      if (!isClickInsideTooltip && activeTooltip !== null) {
        setActiveTooltip(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activeTooltip]);

  const dayDiff = (dateStr) => {
    const today = new Date();
    const target = new Date(dateStr);
    return Math.ceil((target - today) / (1000 * 60 * 60 * 24));
  };

  // Format date as dd-mm-yyyy
  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formattedMedicineNotTaken = medicineNotTakenList.map((p) => ({
    id: p.patient_id,
    name: formatName(
      `${p.first_name} ${p.middile_name || ""} ${p.last_name}`.trim()
    ),
    phone: p.whatsapp_contact_no,
    createdAt: formatDate(p.created_at, false, true),
  }));

  // useEffect(() => {
  //   let d7 = [];
  //   let d15 = [];
  //   let d21 = [];

  //   upcomingFollowUps.forEach((item) => {
  //     const diff = dayDiff(item.reminderDate);
  //     const patientData = {
  //       name: item.patientName,
  //       reminderDate: formatDate(item.reminderDate), // Use formatted date
  //     };

  //     if (diff === 7) d7.push(patientData);
  //     if (diff === 15) d15.push(patientData);
  //     if (diff === 21) d21.push(patientData);
  //   });

  //   setGroupedFollowUps({ d7, d15, d21 });
  // }, []);
  const formattedEmergencyPatients = emergencyPatients.map((p) => ({
    id: p.patient_id,
    name: `${p.first_name || ""} ${p.middile_name || ""} ${p.last_name || ""}`.trim(),
    phone: p.whatsapp_contact_no,
    gender: p.gender,
    disease: p.diseases?.[0]?.disease_name || "N/A",
    service_call_frequency: p.service_call_frequency,
    feedback: p.feedback,
    emergencyMark_doctor_id: p.emergencyMark_doctor_id,
  }));
  const formattedDroppedPatients = droppedPatients.map((p) => ({
    id: p.patient_id,

    name: `${p.first_name || ""} ${p.middile_name || ""} ${p.last_name || ""}`.trim(),

    lastFollowUp: formatDate(p.delivery_date),
    deliveryDate: formatDate(
      p.delivery_date
    ),

    daysDifference:
      p.days_difference,
    days: p.days_difference,
  }));

  // Updated renderCard to include "eye" icon for view details
  const renderCard = (title, list) => (
    <Card>
      <Card.Header>
        <Card.Title className="mb-1">{title}</Card.Title>
      </Card.Header>
      <Card.Body
        style={{
          maxHeight: "400px",
          minHeight: "150px",
          overflowY: "auto",
          display: list.length === 0 ? "flex" : "block",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "0.25rem",
          paddingBottom: "0.25rem",
        }}
      >
        {list.length === 0 ? (
          <p className="text-muted text-center mb-0">No patients</p>
        ) : (
          <ListGroup as="ul" variant="flush">
            {list.map((p, i) => (
              <ListGroup.Item
                key={i}
                as="li"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                  padding: "8px 10px",
                }}
              >
                {/* Patient Name */}
                <div >
                  < span>{p.name} </span>
                </div>

                {/* Eye Icon (View Details) */}
                <Link
                  to="/view-details"
                  state={{
                    patientId: p.id,
                    patientName: p.name,
                    patientGender: p.gender,
                  }}
                  title="View Patient Details"
                
                >
                  <i className="fa fa-eye" aria-hidden="true"></i>
                </Link>

                {/* Optional Phone/Call Icon (uncomment if needed) */}
                {/* {p.phone && (
                  <a href={`tel:${p.phone}`} style={{ color: "#198754", fontSize: "18px" }}>
                    <i className="fa fa-phone" aria-hidden="true"></i>
                  </a>
                )} */}
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Card.Body>
    </Card>
  );

  const formatOptionLabel = ({ label, specialization }) => (
    <div>
      <div style={{ fontWeight: "bold" }}>{label}</div>
      <div style={{ fontSize: "0.8em", color: "#666" }}>{specialization}</div>
    </div>
  )

  const uniquePatientsMap = {};

  patients.forEach((p) => {
    if (!uniquePatientsMap[p.id]) {
      uniquePatientsMap[p.id] = p;
    }
  });

  const uniquePatients = Object.values(uniquePatientsMap);
  const patientCounts = {};

  patients.forEach((p) => {
    patientCounts[p.id] = (patientCounts[p.id] || 0) + 1;
  });

  // const repeatPatients = patients.filter(
  //   (p) => patientCounts[p.id] > 1
  // );
  const formattedRepeatPatients = repeatPatients.map((p) => ({
    id: p.patient_id,
    name: formatName(`${p.first_name} ${p.middile_name || ""} ${p.last_name}`.trim()),
    createdAt: formatDate(p.created_at, false, true),
    phone: p.whatsapp_contact_no,
  }));
  return (
    <div>


      <div className="row">
        {/* <div className="col-xl-3 col-xxl-6 col-sm-6">
          <div className="card gradient-bx text-white bg-danger rounded">
            <div className="card-body">
              <div className="media align-items-center">
                <div className="media-body">
                  <p className="mb-1">Total Assign Patients</p>
                  <div className="d-flex flex-wrap">
                    <h2 className="fs-40 font-w600 text-white mb-0 me-3">{TotalAssignPatients}</h2>
                    <div>
                      <svg width={28} height={19} viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient
                            id="paint0_linear4"
                            x1="13.7187"
                            y1="3.0625"
                            x2="14.7499"
                            y2="17.5"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="white" stopOpacity="0.73" offset="0.1" />
                            <stop offset={1} stopColor="white" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <span className="border rounded-circle p-4">
                  <svg width={34} height={34} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M23.6667 0.333311C21.1963 0.264777 18.7993 1.17744 17 2.87164C15.2008 1.17744 12.8038 0.264777 10.3334 0.333311C8.9341 0.337244 7.55292 0.649469 6.28803 1.24778C5.02315 1.84608 3.90564 2.71577 3.01502 3.79498C-0.039984 7.45998 -0.261651 13.3333 1.19668 17.5966C1.21002 17.6266 1.22002 17.6566 1.23335 17.6866C3.91168 25.3333 15.2717 33.6666 17 33.6666C18.6983 33.6666 30.025 25.5166 32.7667 17.6866C32.78 17.6566 32.79 17.6266 32.8034 17.5966C34.2417 13.4016 34.0867 7.51498 30.985 3.79498C30.0944 2.71577 28.9769 1.84608 27.712 1.24778C26.4471 0.649469 25.0659 0.337244 23.6667 0.333311ZM17 30.03C14.6817 28.5233 8.23168 24 5.30335 18.6666H12C12.2743 18.6667 12.5444 18.599 12.7863 18.4696C13.0282 18.3403 13.2344 18.1532 13.3867 17.925L14.83 15.7583L17.0867 22.525C17.1854 22.8207 17.3651 23.0829 17.6054 23.2816C17.8456 23.4803 18.1368 23.6076 18.4458 23.6491C18.7548 23.6906 19.0693 23.6446 19.3535 23.5163C19.6376 23.388 19.8801 23.1825 20.0533 22.9233L22.8917 18.6666H28.6984C25.7684 24 19.3183 28.5233 17 30.03ZM29.975 15.3333H22C21.7257 15.3333 21.4556 15.4009 21.2137 15.5303C20.9718 15.6597 20.7656 15.8468 20.6133 16.075L19.17 18.2416L16.9133 11.475C16.8146 11.1792 16.6349 10.9171 16.3947 10.7184C16.1544 10.5196 15.8632 10.3923 15.5542 10.3508C15.2452 10.3093 14.9307 10.3553 14.6466 10.4837C14.3624 10.612 14.1199 10.8174 13.9467 11.0766L11.1084 15.3333H4.02502C3.35835 12.1816 3.50502 8.41164 5.57668 5.92831C6.151 5.22081 6.87614 4.65057 7.69911 4.25927C8.52209 3.86797 9.42209 3.6655 10.3334 3.66664C15.445 3.66664 14.9117 7.16664 16.9817 7.18664H17C19.0733 7.18664 18.5483 3.66664 23.6667 3.66664C24.5785 3.665 25.4792 3.86723 26.3027 4.25855C27.1263 4.64987 27.852 5.22037 28.4267 5.92831C30.4867 8.40331 30.6467 12.1666 29.975 15.3333Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div> */}



        {/* <div className="col-xl-9 col-xxl-6 col-sm-6">
          <div className="card gradient-bx text-white bg-success rounded">
            <div className="card-body">
              <div className="media align-items-center">
                <div className="media-body">
                  <p className="mb-1">Monthly Monthly Follow-Up Summary</p>
                  <div className="d-flex flex-wrap">
                    <h2 className="fs-40 font-w600 text-white mb-0 me-3"></h2>
                    <div>
                      <svg width={28} height={19} viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient
                            id="paint0_linear1"
                            x1="13.7188"
                            y1="3.0625"
                            x2="12.6875"
                            y2="17.5"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="white" stopOpacity="0.73" offset="0.1" />
                            <stop offset={1} stopColor="white" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <span className="border rounded-circle p-4">
                  <svg width={34} height={34} viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M37.3333 15.6666C37.3383 14.7488 37.0906 13.8473 36.6174 13.061C36.1441 12.2746 35.4635 11.6336 34.6501 11.2084C33.8368 10.7831 32.9221 10.5899 32.0062 10.65C31.0904 10.7101 30.2087 11.021 29.4579 11.5489C28.707 12.0767 28.1159 12.8011 27.7494 13.6425C27.3829 14.484 27.255 15.4101 27.3799 16.3194C27.5047 17.2287 27.8774 18.086 28.4572 18.7976C29.0369 19.5091 29.8013 20.0473 30.6667 20.3533V25.6666C30.6667 27.8768 29.7887 29.9964 28.2259 31.5592C26.6631 33.122 24.5435 34 22.3333 34C20.1232 34 18.0036 33.122 16.4408 31.5592C14.878 29.9964 14 27.8768 14 25.6666V23.8666C16.7735 23.4642 19.3097 22.0777 21.1456 19.9603C22.9815 17.8429 23.9946 15.1358 24 12.3333V2.33329C24 1.89127 23.8244 1.46734 23.5118 1.15478C23.1993 0.842221 22.7754 0.666626 22.3333 0.666626H17.3333C16.8913 0.666626 16.4674 0.842221 16.1548 1.15478C15.8423 1.46734 15.6667 1.89127 15.6667 2.33329C15.6667 2.77532 15.8423 3.19924 16.1548 3.5118C16.4674 3.82436 16.8913 3.99996 17.3333 3.99996H20.6667V12.3333C20.6667 14.5434 19.7887 16.663 18.2259 18.2258C16.6631 19.7887 14.5435 20.6666 12.3333 20.6666C10.1232 20.6666 8.00358 19.7887 6.44077 18.2258C4.87797 16.663 4 14.5434 4 12.3333V3.99996H7.33333C7.77536 3.99996 8.19928 3.82436 8.51184 3.5118C8.8244 3.19924 9 2.77532 9 2.33329C9 1.89127 8.8244 1.46734 8.51184 1.15478C8.19928 0.842221 7.77536 0.666626 7.33333 0.666626H2.33333C1.8913 0.666626 1.46738 0.842221 1.15482 1.15478C0.842259 1.46734 0.666664 1.89127 0.666664 2.33329V12.3333C0.672024 15.1358 1.68515 17.8429 3.52106 19.9603C5.35697 22.0777 7.8932 23.4642 10.6667 23.8666V25.6666C10.6667 28.7608 11.8958 31.7283 14.0837 33.9162C16.2717 36.1041 19.2391 37.3333 22.3333 37.3333C25.4275 37.3333 28.395 36.1041 30.5829 33.9162C32.7708 31.7283 34 28.7608 34 25.6666V20.3533C34.9723 20.0131 35.8151 19.3797 36.4122 18.5402C37.0092 17.7008 37.3311 16.6967 37.3333 15.6666Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="col-xl-3 col-xxl-6 col-sm-6">
          <div className="card gradient-bx text-white bg-info rounded">
            <div className="card-body">
              <div className="media align-items-center">
                <div className="media-body">
                  <p className="mb-1">Appointment Books</p>
                  <div className="d-flex flex-wrap">
                    <h2 className="fs-40 font-w600 text-white mb-0 me-3">76</h2>
                    <div>
                      <svg width={28} height={19} viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient
                            id="paint0_linear2"
                            x1="13.7188"
                            y1="3.0625"
                            x2="12.6875"
                            y2="17.5"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="white" stopOpacity="0.73" offset="0.1" />
                            <stop offset={1} stopColor="white" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <span className="border rounded-circle p-4">
                  <svg width={34} height={34} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0)">
                      <path
                        d="M35 5H33.3333C33.3333 3.67392 32.8065 2.40215 31.8689 1.46447C30.9312 0.526784 29.6594 0 28.3333 0C27.0072 0 25.7355 0.526784 24.7978 1.46447C23.8601 2.40215 23.3333 3.67392 23.3333 5H16.6667C16.6667 3.67392 16.1399 2.40215 15.2022 1.46447C14.2645 0.526784 12.9927 7.45058e-08 11.6667 7.45058e-08C10.3406 7.45058e-08 9.06881 0.526784 8.13113 1.46447C7.19345 2.40215 6.66667 3.67392 6.66667 5H5C3.67392 5 2.40215 5.52678 1.46447 6.46447C0.526784 7.40215 0 8.67392 0 10L0 35C0 36.3261 0.526784 37.5979 1.46447 38.5355C2.40215 39.4732 3.67392 40 5 40H35C36.3261 40 37.5979 39.4732 38.5355 38.5355C39.4732 37.5979 40 36.3261 40 35V10C40 8.67392 39.4732 7.40215 38.5355 6.46447C37.5979 5.52678 36.3261 5 35 5ZM5 8.33333H6.66667C6.66667 9.65942 7.19345 10.9312 8.13113 11.8689C9.06881 12.8065 10.3406 13.3333 11.6667 13.3333C12.1087 13.3333 12.5326 13.1577 12.8452 12.8452C13.1577 12.5326 13.3333 12.1087 13.3333 11.6667C13.3333 11.2246 13.1577 10.8007 12.8452 10.4882C12.5326 10.1756 12.1087 10 11.6667 10C11.2246 10 10.8007 9.8244 10.4882 9.51184C10.1756 9.19928 10 8.77536 10 8.33333V5C10 4.55797 10.1756 4.13405 10.4882 3.82149C10.8007 3.50893 11.2246 3.33333 11.6667 3.33333C12.1087 3.33333 12.5326 3.50893 12.8452 3.82149C13.1577 4.13405 13.3333 4.55797 13.3333 5V6.66667C13.3333 7.10869 13.5089 7.53262 13.8215 7.84518C14.134 8.15774 14.558 8.33333 15 8.33333H23.3333C23.3333 9.65942 23.8601 10.9312 24.7978 11.8689C25.7355 12.8065 27.0072 13.3333 28.3333 13.3333C28.7754 13.3333 29.1993 13.1577 29.5118 12.8452C29.8244 12.5326 30 12.1087 30 11.6667C30 11.2246 29.8244 10.8007 29.5118 10.4882C29.1993 10.1756 28.7754 10 28.3333 10C27.8913 10 27.4674 9.8244 27.1548 9.51184C26.8423 9.19928 26.6667 8.77536 26.6667 8.33333V5C26.6667 4.55797 26.8423 4.13405 27.1548 3.82149C27.4674 3.50893 27.8913 3.33333 28.3333 3.33333C28.7754 3.33333 29.1993 3.50893 29.5118 3.82149C29.8244 4.13405 30 4.55797 30 5V6.66667C30 7.10869 30.1756 7.53262 30.4882 7.84518C30.8007 8.15774 31.2246 8.33333 31.6667 8.33333H35C35.442 8.33333 35.866 8.50893 36.1785 8.82149C36.4911 9.13405 36.6667 9.55797 36.6667 10V16.6667H3.33333V10C3.33333 9.55797 3.50893 9.13405 3.82149 8.82149C4.13405 8.50893 4.55797 8.33333 5 8.33333ZM35 36.6667H5C4.55797 36.6667 4.13405 36.4911 3.82149 36.1785C3.50893 35.866 3.33333 35.442 3.33333 35V20H36.6667V35C36.6667 35.442 36.4911 35.866 36.1785 36.1785C35.866 36.4911 35.442 36.6667 35 36.6667Z"
                        fill="white"
                      />
                      <path
                        d="M20 26.6667C20.9205 26.6667 21.6667 25.9205 21.6667 25C21.6667 24.0795 20.9205 23.3333 20 23.3333C19.0795 23.3333 18.3333 24.0795 18.3333 25C18.3333 25.9205 19.0795 26.6667 20 26.6667Z"
                        fill="white"
                      />
                      <path
                        d="M30 26.6667C30.9205 26.6667 31.6667 25.9205 31.6667 25C31.6667 24.0795 30.9205 23.3333 30 23.3333C29.0796 23.3333 28.3334 24.0795 28.3334 25C28.3334 25.9205 29.0796 26.6667 30 26.6667Z"
                        fill="white"
                      />
                      <path
                        d="M9.99995 26.6667C10.9204 26.6667 11.6666 25.9205 11.6666 25C11.6666 24.0795 10.9204 23.3333 9.99995 23.3333C9.07947 23.3333 8.33328 24.0795 8.33328 25C8.33328 25.9205 9.07947 26.6667 9.99995 26.6667Z"
                        fill="white"
                      />
                      <path
                        d="M20 33.3334C20.9205 33.3334 21.6667 32.5872 21.6667 31.6667C21.6667 30.7462 20.9205 30 20 30C19.0795 30 18.3333 30.7462 18.3333 31.6667C18.3333 32.5872 19.0795 33.3334 20 33.3334Z"
                        fill="white"
                      />
                      <path
                        d="M30 33.3334C30.9205 33.3334 31.6667 32.5872 31.6667 31.6667C31.6667 30.7462 30.9205 30 30 30C29.0796 30 28.3334 30.7462 28.3334 31.6667C28.3334 32.5872 29.0796 33.3334 30 33.3334Z"
                        fill="white"
                      />
                      <path
                        d="M9.99995 33.3334C10.9204 33.3334 11.6666 32.5872 11.6666 31.6667C11.6666 30.7462 10.9204 30 9.99995 30C9.07947 30 8.33328 30.7462 8.33328 31.6667C8.33328 32.5872 9.07947 33.3334 9.99995 33.3334Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width={40} height={40} fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="col-xl-3 col-xxl-6 col-sm-6">
          <div className="card gradient-bx text-white bg-secondary rounded">
            <div className="card-body">
              <div className="media align-items-center">
                <div className="media-body">
                  <p className="mb-1">Hospital Earning</p>
                  <div className="d-flex flex-wrap">
                    <h2 className="fs-40 font-w600 text-white mb-0 me-3">$56k</h2>
                    <div>
                      <svg width={28} height={19} viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient
                            id="paint0_linear3"
                            x1="13.7187"
                            y1="3.0625"
                            x2="14.7499"
                            y2="17.5"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="white" stopOpacity="0.73" offset="0.1" />
                            <stop offset={1} stopColor="white" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <span className="border rounded-circle p-4">
                  <svg width={34} height={34} viewBox="0 0 21 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.21864 35H11.6667V31.7747C17.7104 31.496 21.0001 27.7133 21.0001 23.413C21.0001 17.2412 15.7596 16.0865 11.6667 14.8919V8.72014C12.7378 9.11832 13.4645 10.0341 13.6175 11.5074H20.6175C20.2733 6.45051 16.9072 3.66325 11.6667 3.22526V0H9.21864V3.22526C4.01645 3.58362 6.10352e-05 6.53015 6.10352e-05 11.5074C6.10352e-05 17.7588 5.12574 18.9534 9.21864 20.0683V26.3595C7.91809 25.9215 7.15307 24.9261 7.00006 23.2935H0.0383124C0.229569 28.43 4.01645 31.2571 9.21864 31.7349V35ZM14.1531 23.6519C14.1531 25.1251 13.1968 26.2002 11.6667 26.479V20.8248C13.1585 21.4221 14.1531 22.2184 14.1531 23.6519ZM6.92356 11.1889C6.92356 9.63595 7.80334 8.75995 9.21864 8.52105V14.0557C7.84159 13.4187 6.92356 12.5825 6.92356 11.1889Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div className="row mb-3">
        <div className="col-xl-4">
          {renderCard("7-Days Service Call", groupedFollowUps.d7)}
        </div>

        <div className="col-xl-4">
          {renderCard("15-Days Service Call", groupedFollowUps.d15)}
        </div>

        <div className="col-xl-4">
          {renderCard("21-Days Service Call", groupedFollowUps.d21)}
        </div>
      </div>
      <div className="row mb-3">

        {/* Patient List Card */}
        <div className="col-xl-4 col-lg-6 col-md-12 mb-3">

          <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
        
  <Card.Title className="mb-0 d-flex align-items-center">
    Patient List

    {Number(TotalAssignPatients) > 0 && (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>Total Assign Patients</Tooltip>}
      >
   <span
  className="ms-2"
  style={{
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    backgroundColor: "#e3f2fd",
 color: "#0d47a1",
    borderRadius: "50%",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  }}
>
  {TotalAssignPatients}
</span>
      </OverlayTrigger>
    )}
  </Card.Title>

</Card.Header>
            <Card.Body
              style={{
                maxHeight: "500px",
                paddingTop: "0px",
                overflowY: "auto",
                paddingBottom: "10px",
                // overflowY: "auto",
                display: patientsLoading || patients.length === 0 ? "flex" : "block",
                justifyContent:
                  patientsLoading || patients.length === 0 ? "center" : "flex-start",
                alignItems:
                  patientsLoading || patients.length === 0 ? "center" : "flex-start",
                // paddingTop: "10px",       // ⭐ Patient list la top padding
              }}
            >

              {patientsLoading ? (
                <Loader />
              ) : uniquePatients.length > 0 ? (

                <ListGroup as="ul" variant="flush">

                  {uniquePatients.map((item, i) => {
                    const isRepeatPatient = patientCounts[item.id] > 1;

                    const content = (
                      <ListGroup.Item
                        as="li"
                        key={i}
                        style={{
                          marginTop: "10px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          background: item.medicineNotTaken ? "#ffe6e6" : "white",
                          borderLeft: item.medicineNotTaken ? "5px solid red" : "none",
                          cursor: item.medicineNotTaken ? "pointer" : "default",
                          // background: item.isRegularServiceCall ? "rgba(0,123,255,0.05)" : "white",
                          // borderLeft: item.isRegularServiceCall ? "4px solid #0d6efd" : "none",
                        }}
                      >
                        {/* LEFT BLOCK */}
                        {/* <div style={{ flex: 1, minWidth: 0 }}> */}
                        <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>


                          <OverlayTrigger
                            show={activeTooltip === `patient-${item.id}`}
                            trigger="click"
                            placement={getTooltipPlacement()}
                            overlay={
                              <Tooltip
                                id={`tooltip-${item.id}`}
                                style={{
                                  maxWidth: "300px",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  backgroundColor: "#fff",
                                  border: "1px solid #ccc",
                                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                                  zIndex: 9999,
                                }}
                              >
                                <div>
                                  <strong>{item.name}</strong>
                                  <br />
                                  <span>Patient Code: {item.patientCode}</span>
                                  <br />
                                  <span>Gender: {item.gender}</span>
                                  <br />


                                  <span>Disease: {item.disease}</span>
                                  <br />

                                  <span>Email: {item.email}</span>
                                  <br />
                                  <span>Phone: {item.phone}</span>

                                </div>
                              </Tooltip>
                            }
                          >
                            <span
                              style={{ cursor: "pointer", display: "inline-block" }}
                              onClick={() => handleTooltipToggle(`patient-${item.id}`)}
                            >
                              {/* Name */}
                              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <span>{item.name}</span>

                                {isRepeatPatient && (
                                  <span className="badge bg-warning text-dark">
                                    Repeat
                                  </span>
                                )}
                              </div>


                              {/* Date */}


                            </span>

                          </OverlayTrigger>

                          {/* Toggles */}
                          {/* <div className="d-flex mt-2" style={{ gap: "20px" }}>
                            <div className="d-flex flex-column text-center">
                              <label style={{ fontSize: "12px" }}>Google Review</label>
                              <input
                                type="checkbox"
                                checked={item.googleReview}
                                onChange={() => {
                                  const updated = [...patients];
                                  updated[i].googleReview = !updated[i].googleReview;
                                  setPatients(updated);
                                }}
                              />
                            </div>

                            <div className="d-flex flex-column text-center">
                              <label style={{ fontSize: "12px" }}>Testimonial</label>
                              <input
                                type="checkbox"
                                checked={item.testimonial}
                                onChange={() => {
                                  const updated = [...patients];
                                  updated[i].testimonial = !updated[i].testimonial;
                                  setPatients(updated);
                                }}
                              />
                            </div>
                          </div> */}
                        </div>

                        {/* RIGHT BLOCK */}
                        {/* <div className="d-flex align-items-center flex-shrink-0" style={{ gap: "6px" }}> */}
                        <div className="d-flex align-items-center" style={{ gap: "10px", flexShrink: 0 }}>


                          <div className="d-flex align-items-center">

                            {/* Send */}
                            {/* <button
                              className="btn d-flex align-items-center justify-content-center me-2"
                              onClick={() => handleSendFollowup(item)}
                              title="Send follow-up schedule"
                              style={{ width: "32px", height: "32px", padding: "0" }}
                            >
                              <img
                                src={sendFolloupIcon}
                                alt="Send"
                                style={{ width: "20px", height: "20px" }}
                              />
                            </button> */}

                            {/* Reassign */}
                            {/* <button
                              className="btn d-flex align-items-center justify-content-center me-2"
                              onClick={() => handleReassign(item)}
                              title="Re-assign Patient"
                              style={{ width: "32px", height: "32px", padding: "0" }}
                            >
                              <img
                                src={reassign}
                                alt="Reassign"
                                style={{ width: "20px", height: "20px" }}
                              />
                            </button> */}

                            {/* Emergency */}
                            <button
                              className="btn d-flex align-items-center justify-content-center me-2"
                              onClick={() => openEmergencyPopup(item)}
                              title="Mark as Emergency"
                              style={{ width: "32px", height: "32px", padding: "0" }}
                            >
                              <img src={emergencyIcon} alt="Emergency" style={{ width: "20px", height: "20px" }} />
                            </button>


                            {/* Call */}
                            <a href={`tel:${item.phone}`}>
                              <img
                                src={icon || "/placeholder.svg"}
                                alt="Call Icon"
                                style={{
                                  cursor: "pointer",
                                  width: "24px",
                                  height: "24px",
                                }}
                                title="Call"
                              />
                            </a>

                            {/* Eye */}
                            <Link
                              to="/view-details"
                              className="ms-3"
                              state={{
                                patientId: item.id,
                                patientName: item.name,
                                patientGender: item.gender,
                                patientPhone: item.phone,
                                patientEmail: item.email,
                                patientDOB: item.dob,
                                patientDisease: item.disease,
                                patientStatus: item.status,
                                patientCode: item.patientCode,
                                patientCreatedAt: item.createdAt,
                              }}
                              style={{ textDecoration: "none", color: "inherit" }}
                              title="Preview Patient"
                            >
                              <i className="fa fa-eye fs-18" aria-hidden="true"></i>
                            </Link>
                          </div>
                        </div>

                      </ListGroup.Item>
                    );

                    // APPLY TOOLTIP ONLY WHEN medicineNotTaken = true
                    return item.medicineNotTaken ? (
                      <OverlayTrigger
                        key={i}
                        trigger="hover"
                        placement="right"
                        overlay={<Tooltip id={`mednot-${i}`}>Medicine not taken</Tooltip>}
                      >
                        <div style={{ width: "100%" }}>{content}</div>
                      </OverlayTrigger>
                    ) : (
                      content
                    );
                  })}
                </ListGroup>
              ) : (
                <div className="text-muted text-center">
                  <strong>No patient data found.</strong>
                </div>
              )}

            </Card.Body>
          </Card>
        </div>

        {/* Today's Follow-Up Reminders Card */}
        <div className="col-xl-4 col-lg-6 col-md-12 mb-3">
  <Card>
    <Card.Header>
      <Card.Title>Today's Service Call Reminders</Card.Title>
    </Card.Header>
    <Card.Body
      style={{
        maxHeight: "500px",
        paddingTop: "0px",
        overflowY: "auto",
        paddingBottom: "10px",
        display: todayFollowUpsLoading || todayFollowUps.length === 0 ? "flex" : "block",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "200px",
      }}
    >
      {todayFollowUpsLoading ? (
        <Loader />
      ) : todayFollowUps.length > 0 ? (
        <>
          <ListGroup as="ul" variant="flush">
            {todayFollowUps.map((item, i) => (
              <ListGroup.Item
                as="li"
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  background: item.medicineNotTaken ? "#ffe6e6" : "white",
                  borderLeft: item.medicineNotTaken ? "5px solid red" : "none",
                }}
              >
                <div>
                  <OverlayTrigger
                    show={activeTooltip === `today-${item.reminderId}`}
                    trigger="click"
                    placement={getTooltipPlacement()}
                    overlay={
                      <Tooltip
                        id={`tooltip-today-${item.reminderId}`}
                        style={{
                          maxWidth: "300px",
                          padding: "10px",
                          borderRadius: "5px",
                          backgroundColor: "#fff",
                          border: "1px solid #ccc",
                          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                          fontSize: "14px",
                          zIndex: 9999,
                        }}
                      >
                        <div>
                          <strong>{item.name}</strong>
                          <br />
                          <span>Reminder ID: {item.reminderId}</span>
                          <br />
                          <span>{item.action}</span>
                          <br />
                          <span>Next action: {item.nextAction}</span>
                          <br />
                          <span>Status: {item.status}</span>
                          <br />
                          {item.patientId && (
                            <>
                              <span>Patient ID: {item.patientId}</span>
                              <br />
                            </>
                          )}
                          {item.whatsappContactNo && (
                            <>
                              <span>WhatsApp: {item.whatsappContactNo}</span>
                              <br />
                            </>
                          )}
                          <span>Admin ID: {item.adminId}</span>
                          <br />
                          {item.followupId && (
                            <>
                              <span>Followup ID: {item.followupId}</span>
                              <br />
                            </>
                          )}
                        </div>
                      </Tooltip>
                    }
                  >
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => handleTooltipToggle(`today-${item.reminderId}`)}
                    >
                      {item.name}
                      <br />
                            <span style={{ fontSize: "14px", color: "#6c757d" }}>
                            {item.date}
                            </span>
                    </span>
                      
                  </OverlayTrigger>
                </div>
                <div className="d-flex align-items-center">
                  <button
                    className="btn d-flex align-items-center justify-content-center me-1"
                    onClick={() => openEmergencyPopup(item)}
                    title="Mark as Emergency"
                    style={{ width: "32px", height: "32px", padding: "0" }}
                  >
                    <img
                      src={emergencyIcon}
                      alt="Emergency"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </button>
                  <a href={`tel:${item.whatsappContactNo}`}>
                    <img
                      src={icon || "/placeholder.svg"}
                      alt="Call Icon"
                      style={{
                        cursor: "pointer",
                        marginLeft: "8px",
                        width: "24px",
                        height: "24px",
                      }}
                      title="Call"
                    />
                  </a>
                  <Link
                    to="/view-details"
                    className="view detail ms-2"
                    state={{
                      reminderId: item.reminderId,
                      patientId: item.patientId,
                      patientName: item.name,
                      reminderStatus: item.status,
                      prescriptionId: item.prescriptionId,
                      followupId: item.followupId,
                      whatsappContactNo: item.whatsappContactNo,
                      adminId: item.adminId,
                      reminderDate: item.reminderDate,
                      reminderTime: item.reminderTime,
                      reminderType: "today",
                    }}
                    title="View Details"
                  >
                    <i className="fa fa-eye fs-18" aria-hidden="true"></i>
                  </Link>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>

          {/* Other Followups Section */}
          {otherFollowups.length > 0 && (
            <div style={{ marginTop: "10px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "6px",
                }}
              >
                <div style={{ flex: 1, height: "1px", background: "#dee2e6" }}></div>
             
                <div style={{ flex: 1, height: "1px", background: "#dee2e6" }}></div>
              </div>
              {otherFollowups.map((f, idx) => (
                <div key={idx} style={{ fontSize: "13px", color: "#6c757d", padding: "2px 0" }}>
                  • {f.followup_count}
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <div className="text-muted text-center">
          <p>No follow-up reminders for today.</p>
        </div>
      )}
    </Card.Body>
  </Card>
</div>

        {/* Upcoming Follow-Up Reminders Card */}
        <div className="col-xl-4 col-lg-6 col-md-12 mb-3">
          <Card>
            <Card.Header>
              <Card.Title>Upcoming Service Call Reminders</Card.Title>
            </Card.Header>
            <Card.Body
              style={{
                maxHeight: "800px",
                paddingTop: "0px",
                overflowY: "auto",
                paddingBottom: "10px",
                display: upcomingFollowUpsLoading || upcomingFollowUps.length === 0 ? "flex" : "block",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "200px",
              }}
            >
              {upcomingFollowUpsLoading ? (
                <Loader />
              ) : upcomingFollowUps.length > 0 ? (
                <ListGroup as="ul" variant="flush">
                  {upcomingFollowUps.map((item, i) => (
                    <ListGroup.Item
                      as="li"
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: item.medicineNotTaken ? "#ffe6e6" : "white",
                        borderLeft: item.medicineNotTaken ? "5px solid red" : "none",
                      }}
                    >

                      <div>
                        <OverlayTrigger
                          show={activeTooltip === `upcoming-${item.reminderId}`}
                          trigger="click"
                          placement={getTooltipPlacement()}
                          overlay={
                            <Tooltip
                              id={`tooltip-upcoming-${item.reminderId}`}
                              style={{
                                maxWidth: "300px",
                                padding: "10px",
                                borderRadius: "5px",
                                backgroundColor: "#fff",
                                border: "1px solid #ccc",
                                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                                fontSize: "14px",
                                zIndex: 9999,
                              }}
                            >
                              <div>
                                <strong>{item.name}</strong>
                                <br />
                                <span>Reminder ID: {item.reminderId}</span>
                                <br />
                                <span>{item.action}</span>
                                <br />
                                <span>Next action: {item.nextAction}</span>
                                <br />
                                <span>Status: {item.status}</span>
                                <br />
                                {item.patientId && (
                                  <>
                                    <span>Patient ID: {item.patientId}</span>
                                    <br />
                                  </>
                                )}
                                {item.whatsappContactNo && (
                                  <>
                                    <span>WhatsApp: {item.whatsappContactNo}</span>
                                    <br />
                                  </>
                                )}
                                <span>Admin ID: {item.adminId}</span>
                                <br />
                                {item.followupId && (
                                  <>
                                    <span>Followup ID: {item.followupId}</span>
                                    <br />
                                  </>
                                )}
                              </div>
                            </Tooltip>
                          }
                        >
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => handleTooltipToggle(`upcoming-${item.reminderId}`)}
                          >
                            {item.name}
                            <br />
                            <span style={{ fontSize: "14px", color: "#6c757d" }}>
                            {item.date}
                            </span>
                          </span>
                        </OverlayTrigger>
                      </div>
                      <div className="d-flex align-items-center">
                        {/* <button
                          className="btn d-flex align-items-center justify-content-center me-2"
                          onClick={() => handleSendFollowup(item)}
                          title="Send follow-up schedule"
                          style={{ width: "32px", height: "32px", padding: "0" }}
                        >
                          <img
                            src={sendFolloupIcon}
                            alt="Send"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </button>

                      
                        <button
                          className="btn d-flex align-items-center justify-content-center me-2"
                          onClick={() => handleReassign(item)}
                          title="Re-assign Patient"
                          style={{ width: "32px", height: "32px", padding: "0" }}
                        >
                          <img
                            src={reassign}
                            alt="Reassign"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </button> */}

                        {/* Emergency */}
                        <button
                          className="btn d-flex align-items-center justify-content-center me-1s"
                          onClick={() => openEmergencyPopup(item)}
                          title="Mark as Emergency"
                          style={{ width: "32px", height: "32px", padding: "0" }}
                        >
                          <img
                            src={emergencyIcon}
                            alt="Emergency"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </button>

                        <a href={`tel:${item.whatsappContactNo}`}>
                          <img
                            src={icon || "/placeholder.svg"}
                            alt="Call Icon"
                            style={{
                              cursor: "pointer",
                              marginLeft: "8px",
                              width: "24px",
                              height: "24px",
                            }}
                            title="Call"
                          />
                        </a>
                        <Link
                          to="/view-details"
                          className="view detail ms-2"
                          state={{
                            reminderId: item.reminderId,
                            patientId: item.patientId,
                            patientName: item.name,
                            reminderStatus: item.status,
                            prescriptionId: item.prescriptionId,
                            followupId: item.followupId,
                            whatsappContactNo: item.whatsappContactNo,
                            adminId: item.adminId,
                            reminderDate: item.reminderDate,
                            reminderTime: item.reminderTime,
                            reminderType: "upcoming",
                          }}
                          title="View Details"
                        >
                          <i className="fa fa-eye fs-18" aria-hidden="true"></i>
                        </Link>
                        {/* <button
                          className="btn btn-sm btn-primary ms-3"
                          onClick={() => handleSendFollowup(item)}
                          title="Send follow-up schedule"
                        >
                          Send
                        </button>
                        <button
                          className="btn btn-sm btn-warning ms-3 d-flex align-items-center justify-content-center"
                          onClick={() => handleReassign(item)}
                          title="Re-assign Patient"
                          style={{ width: "32px", height: "32px", padding: "0" }}
                        >
                          <img
                            src={reassign}
                            alt="Reassign"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </button> */}


                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              ) : (
                <div className="text-muted text-center">
                  <p>No upcoming follow-up reminders.</p>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
        <div className="col-xl-4 col-lg-6 col-md-12 mb-3">
          <Card>
            <Card.Header className="bg-danger text-white">
              <Card.Title>🚨 Emergency Patients</Card.Title>
            </Card.Header>

            <Card.Body
              style={{
                maxHeight: "500px",
                paddingTop: "0px",
                overflowY: "auto",
                paddingBottom: "10px",
                display:
                  formattedEmergencyPatients.length === 0 ? "flex" : "block",
                justifyContent:
                  formattedEmergencyPatients.length === 0
                    ? "center"
                    : "flex-start",
                alignItems:
                  formattedEmergencyPatients.length === 0
                    ? "center"
                    : "flex-start",
              }}
            >
              {formattedEmergencyPatients.length > 0 ? (
                <ListGroup as="ul" variant="flush">
                  {formattedEmergencyPatients.map((item, i) => (
                    <ListGroup.Item
                      as="li"
                      key={i}
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "#ffe6e6",
                        borderLeft: "5px solid red",
                      }}
                    >
                      {/* LEFT BLOCK */}
                      <div
                        style={{
                          flex: 1,
                          minWidth: 0,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <span>
                          {item.name}

                          <div
                            style={{
                              fontSize: "13px",
                              color: "#6c757d",
                              marginTop: "2px",
                            }}
                          >
                            {item.phone}
                          </div>
                        </span>
                      </div>

                      {/* RIGHT BLOCK */}
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "10px", flexShrink: 0 }}
                      >
                        {/* CALL */}
                        <a href={`tel:${item.phone}`}>
                          <img
                            src={icon}
                            alt="Call"
                            style={{ width: "24px", height: "24px" }}
                          />
                        </a>

                        {/* VIEW */}
                        <Link
                          to="/view-details"
                          state={{
                            patientId: item.id,
                            patientName: item.name,
                            patientGender: item.gender,
                          }}
                        >
                          <i className="fa fa-eye fs-18"></i>
                        </Link>

                        {/* INFO TOOLTIP ICON */}
                        <OverlayTrigger
                          trigger="click"
                          placement="left"
                          rootClose
                          overlay={
                            <Tooltip style={{ maxWidth: "300px" }}>
                              <div>
                                {item.service_call_frequency?.trim() ||
                                  item.feedback?.trim() ? (
                                  <>
                                    {item.service_call_frequency?.trim() && (
                                      <>
                                        <strong>Service Call Frequency:</strong>
                                        <div>{item.service_call_frequency}</div>
                                      </>
                                    )}

                                    {item.feedback?.trim() && (
                                      <>
                                        <br />
                                        <strong>Feedback:</strong>
                                        <div>{item.feedback}</div>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <div style={{ color: "#ffffff", fontStyle: "italic" }}>
                                    Feedback will be displayed if added by doctor
                                  </div>
                                )}
                              </div>
                            </Tooltip>
                          }
                        >
                          <i
                            className="fa fa-info-circle fs-18"
                            style={{ cursor: "pointer", color: "#dc3545" }}
                          ></i>
                        </OverlayTrigger>

                        {/* CLOSE EMERGENCY */}
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => closeEmergency(item.id)}
                          style={{ padding: "2px 8px", fontSize: "12px" }}
                        >
                          Close
                        </button>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              ) : (
                <div className="text-muted text-center">
                  <strong>No emergency patients.</strong>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
        <div className="col-xl-4 col-lg-6 col-md-12 mb-3">
          <Card>
            <Card.Header className="bg-warning text-dark">
              <Card.Title>⚠️ Dropped Patients</Card.Title>
            </Card.Header>

            <Card.Body
              style={{
                maxHeight: "500px",
                paddingTop: "0px",
                overflowY: "auto",
                paddingBottom: "10px",
                display:
                  formattedDroppedPatients.length === 0 ? "flex" : "block",
                justifyContent:
                  formattedDroppedPatients.length === 0
                    ? "center"
                    : "flex-start",
                alignItems:
                  formattedDroppedPatients.length === 0
                    ? "center"
                    : "flex-start",
              }}
            >
              {formattedDroppedPatients.length > 0 ? (
                <ListGroup as="ul" variant="flush">
                  {formattedDroppedPatients.map((item, i) => (
                    <ListGroup.Item
                      key={i}
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "#fff7e6",
                        borderLeft: "5px solid orange",
                      }}
                    >
                      {/* LEFT BLOCK */}
                      <div
                        style={{
                          flex: 1,
                          minWidth: 0,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <OverlayTrigger
                          trigger="click"
                          placement="right"
                          overlay={
                            <Tooltip style={{ maxWidth: "300px" }}>
                              <div>
                                <strong>{item.name}</strong>
                                <br />
                                <span>Status: {item.status}</span>
                                <br />
                                <span>Delivery Mode: {item.deliveryOption}</span>
                                <br />
                                <span>
                                  Last Delivery: {item.lastFollowUp}
                                </span>
                                <br />
                                <span>{item.daysAgo} days ago</span>
                              </div>
                            </Tooltip>
                          }
                        >
                          <span style={{ cursor: "pointer" }}>
                            {item.name}

                            <div
                              style={{
                                fontSize: "14px",
                                color: "#6c757d",
                                marginTop: "2px",
                              }}
                            >
                             Drop since {item.deliveryDate}   {item.daysDifference} days
                            </div>
      
                           
                          </span>
                        </OverlayTrigger>
                      </div>

                      {/* RIGHT BLOCK */}
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "10px", flexShrink: 0 }}
                      >
                        {/* CALL */}
                        <a href={`tel:${item.phone}`}>
                          <img
                            src={icon}
                            alt="Call"
                            style={{ width: "24px", height: "24px" }}
                            title="Call"
                          />
                        </a>

                        {/* VIEW */}
                        <Link
                          to="/view-details"
                          state={{
                            patientId: item.id,
                            patientName: item.name,
                          }}
                        >
                          <i className="fa fa-eye fs-18"></i>
                        </Link>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              ) : (
                <div className="text-muted text-center">
                  <p>No dropped patients.</p>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
        <div className="col-xl-4 col-lg-6 col-md-12 mb-3">

<Card>

  <Card.Header>
    <Card.Title className="mb-0">
      Routed Patients
    </Card.Title>
  </Card.Header>

  <Card.Body
    style={{
      maxHeight: "400px",
      overflowY: "auto",
    }}
  >

    {routedLoading ? (

      <Loader />

    ) : routedPatients.length === 0 ? (

      <p className="text-muted text-center mb-0">
        No Routed Patients
      </p>

    ) : (

      <ListGroup as="ul" variant="flush">

        {routedPatients.map((item, i) => (

          <ListGroup.Item
          key={`${item.leadId}-${item.id}`}
            as="li"
            className="d-flex justify-content-between align-items-center"
            style={{
              padding: "10px",
            }}
          >

            <div>

              <div
                style={{
                  fontWeight: "600",
                }}
              >
                {item.name}
              </div>

              <small className="text-muted">
            
                {formatDate(item.assignedAt, false, true)}
              </small>

            </div>

            <div className="d-flex align-items-center gap-3 ms-auto">

<Link
  to="/view-details"
  state={{
    patientId: item.id,
  }}
>
  <i
    className="fa fa-eye"
  
  ></i>
</Link>

{completingLeadId === item.leadId ? (
                <div
                  className="spinner-border spinner-border-sm text-success"
                  role="status"
                  style={{ width: "20px", height: "20px" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <img
                  src={completeIcon}
                  alt="complete"
                  style={{
                    width: "20px",
                    height: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleCompleteRoute(item.leadId)}
                />
              )}
</div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    )}
  </Card.Body>
</Card>
</div>
        <div className="col-xl-4 col-lg-6 col-md-12 mb-3">
          <Card>
            <Card.Header className="bg-danger text-white">
              <Card.Title>💊 Medicine Not Taken</Card.Title>
            </Card.Header>

            <Card.Body
              style={{
                maxHeight: "500px",
                overflowY: "auto",
                display:
                  medicineLoading || formattedMedicineNotTaken.length === 0
                    ? "flex"
                    : "block",
                justifyContent:
                  medicineLoading || formattedMedicineNotTaken.length === 0
                    ? "center"
                    : "flex-start",
                alignItems:
                  medicineLoading || formattedMedicineNotTaken.length === 0
                    ? "center"
                    : "flex-start",
              }}
            >
              {medicineLoading ? (
                <Loader />
              ) : formattedMedicineNotTaken.length > 0 ? (
                <ListGroup as="ul" variant="flush">
                  {formattedMedicineNotTaken.map((item, i) => (
                    <ListGroup.Item
                      key={i}
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "#ffe6e6",
                        borderLeft: "5px solid red",
                      }}
                    >
                      {/* LEFT */}
                      <div>
                        <span>{item.name}</span>
                         <br/>
                         <span>{item.createdAt}</span>
                      </div>

                      {/* RIGHT */}
                      <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <a href={`tel:${item.phone}`}>
                          <img src={icon} alt="Call" style={{ width: "24px" }} />
                        </a>

                        <Link
                          to="/view-details"
                          state={{
                            patientId: item.id,
                            patientName: item.name,
                          }}
                        >
                          <i className="fa fa-eye fs-18"></i>
                        </Link>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              ) : (
                <div className="text-muted text-center">
                  <strong>No patients found.</strong>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>

      </div>
      <Modal show={showReassignModal} onHide={() => setShowReassignModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Re-Assign Patient</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Select Service Caller</label>
            <select
              value={selectedCaller}
              className="form-select"
              onChange={(e) => setSelectedCaller(e.target.value)}
            >
              <option value="">Select Caller</option>
              {serviceCallerList.map((c) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowReassignModal(false)}>
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              console.log("Reassigning Patient:", selectedPatient);
              console.log("Assigned To Caller ID:", selectedCaller);

              // 🔥 TODO: Backend Integration when ready
              // dispatch(reassignPatientAction(selectedPatient.id, selectedCaller))

              alert("Reassignment saved (testing only)");
              setShowReassignModal(false);
            }}
            disabled={!selectedCaller}
          >
            Reassign
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <Modal show={showEmergencyModal} onHide={() => setShowEmergencyModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Emergency Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <label className="form-label fw-semibold">Select Doctor</label>

          <Select
            value={selectedDoctorForEmergency}
            onChange={(option) => setSelectedDoctorForEmergency(option)}
            options={doctors.map((doc) => ({
              value: doc.whatsapp_no,        // WhatsApp number
              label: doc.doctor_name,
              specialization: doc.specialization || "-",
            }))}
            formatOptionLabel={formatOptionLabel}
            isClearable
            placeholder="Select a doctor"
            classNamePrefix="select"
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "50px",
                height: "50px",
              }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
          />

          <label className="form-label fw-semibold mt-3">Message to Send</label>
          <textarea
            className="form-control"
            rows={6}
            value={emergencyMessage}
            onChange={(e) => setEmergencyMessage(e.target.value)}
          ></textarea>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEmergencyModal(false)}>
            Cancel
          </Button>

          <Button variant="danger" onClick={sendEmergencyToDoctor}>
            Send to Doctor via WhatsApp
          </Button>
        </Modal.Footer>
      </Modal> */}
      <EmergencyModal
        show={showEmergencyModal}
        onClose={() => setShowEmergencyModal(false)}
        patient={emergencyPatient}

        doctors={doctors}
        onSubmit={sendEmergencyToDoctor}
      />

    </div>

  )
}

export default ServiceCaller
